import Vue from "vue";

const parse = response =>
  response && typeof response.json === "function" ? response.json() : response;

export const getOrCreateStudyDiscussion = studyId =>
  Vue.$http
    .post("/api/discussions/conversations/", {
      context_type: "study",
      study: studyId
    })
    .then(parse);

export const getOrCreateInternalNotes = studyId =>
  Vue.$http
    .post("/api/discussions/internal-notes/", {
      study: studyId
    })
    .then(parse);

export const fetchMessages = (conversationId, params = {}) =>
  Vue.$http
    .get(`/api/discussions/conversations/${conversationId}/messages/`, params)
    .then(parse);

export const sendMessage = (conversationId, payload) =>
  Vue.$http
    .post(`/api/discussions/conversations/${conversationId}/messages/`, {}, payload)
    .then(parse);

export const editMessage = (conversationId, messageId, payload) =>
  Vue.$http
    .patch(
      `/api/discussions/conversations/${conversationId}/messages/${messageId}/`,
      {},
      payload
    )
    .then(parse);

export const deleteMessage = (conversationId, messageId) =>
  Vue.$http
    .remove(`/api/discussions/conversations/${conversationId}/messages/${messageId}/`)
    .then(parse);

export const markRead = (conversationId, messageId) =>
  Vue.$http
    .post(`/api/discussions/conversations/${conversationId}/read/`, {}, {
      message: messageId
    })
    .then(parse);

export const fetchUnread = studyId =>
  Vue.$http.get("/api/discussions/unread/", { study: studyId }).then(parse);

export const exportConversationPdf = conversationId => {
  let tz = "";
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (e) {
    tz = "";
  }
  return Vue.$http
    .get(`/api/discussions/conversations/${conversationId}/export.pdf/`, { tz })
    .then(parse);
};

export const fetchPdfExport = jobId =>
  Vue.$http.get(`/api/discussions/pdf-exports/${jobId}/`).then(parse);

export const downloadPdfExport = jobId =>
  Vue.http.get(`api/discussions/pdf-exports/${jobId}/download/`, {
    responseType: "blob"
  });

export const requestSummary = (conversationId, payload = {}) =>
  Vue.$http
    .post(`/api/discussions/conversations/${conversationId}/summaries/`, {}, payload)
    .then(parse);

export const fetchSummary = summaryId =>
  Vue.$http.get(`/api/discussions/summaries/${summaryId}/`).then(parse);

export const requestViewAnalysis = (conversationId, payload = {}) =>
  Vue.$http
    .post(
      `/api/discussions/conversations/${conversationId}/view-analyses/`,
      {},
      payload
    )
    .then(parse);

export const fetchViewAnalysis = jobId =>
  Vue.$http.get(`/api/discussions/view-analyses/${jobId}/`).then(parse);
